// Marketing landing (landing.html)
import "../../shared/design-tokens/tokens.css";
import "./platform.css";
import { mountIcons } from "./icons.js";
import { brand, applyBrand } from "./brand.js";
const API_BASE = `${brand.apiBase.replace(/\/+$/, "").replace(/\/api\/v1$/i, "")}/api/v1`;

const SNIPPETS = {
  html: `<span class="tok-com">&lt;!-- Paste before &lt;/body&gt; --&gt;</span>
<span class="tok-tag">&lt;script</span>
  <span class="tok-key">src</span>=<span class="tok-str">"${brand.cdnBase}/widget.js"</span>
  <span class="tok-key">data-api-base</span>=<span class="tok-str">"${API_BASE}"</span>
  <span class="tok-key">data-tenant-id</span>=<span class="tok-str">"&lt;tenant-id&gt;"</span>
  <span class="tok-key">data-mode</span>=<span class="tok-str">"customer"</span>
<span class="tok-tag">&gt;&lt;/script&gt;</span>`,
  react: `<span class="tok-key">import</span> { ${brand.name} } <span class="tok-key">from</span> <span class="tok-str">"@${brand.pkgScope}/react"</span>;

<span class="tok-key">export default function</span> <span class="tok-fn">App</span>() {
  <span class="tok-key">return</span> (
    <span class="tok-tag">&lt;${brand.name}</span>
      <span class="tok-key">tenant</span>=<span class="tok-str">"acme-health"</span>
      <span class="tok-key">session</span>={token}
      <span class="tok-key">theme</span>=<span class="tok-str">"warm"</span>
    <span class="tok-tag">/&gt;</span>
  );
}`,
  curl: `<span class="tok-com"># Start a restricted guest session</span>
curl ${API_BASE}/session/guest \\
  -H <span class="tok-str">"Content-Type: application/json"</span> \\
  -d <span class="tok-str">'{ "tenant_id": "&lt;tenant-id&gt;",
       "display_name": "Jordan Meyer" }'</span>`,
};

function initSnippet() {
  const pane = document.getElementById("codepane");
  const tabs = document.getElementById("lt");
  if (!pane || !tabs) return;
  const render = (l) => {
    pane.innerHTML = SNIPPETS[l];
    [...tabs.children].forEach((b) => b.classList.toggle("on", b.dataset.lang === l));
  };
  tabs.addEventListener("click", (e) => {
    const b = e.target.closest("[data-lang]");
    if (b) render(b.dataset.lang);
  });
  render("html");
  const copyBtn = document.getElementById("copyBtn");
  if (copyBtn) {
    copyBtn.addEventListener("click", (e) => {
      navigator.clipboard && navigator.clipboard.writeText(pane.textContent);
      e.target.textContent = "Copied";
      setTimeout(() => (e.target.textContent = "Copy"), 1400);
    });
  }
}

applyBrand();
initSnippet();
mountIcons();
